import React from 'react';
import history from './historyRouter';
import { Router, Route, Switch, Redirect } from 'react-router-dom';
import AdminLayout from 'layouts/Admin.jsx';
import AuthLayout from 'layouts/Auth.jsx';

//New updates
import { v4 as uuidv4 } from 'uuid';

const App = React.memo(() => {

  //Set browser unique ID if not set
  const browser = localStorage.getItem("browser-id");
  if (!browser && crypto) {
    localStorage.setItem("browser-id", uuidv4() );
  }

  //Set session unique ID if not set
  const sessionUniqueId = sessionStorage.getItem("session-id");
  if (!sessionUniqueId && crypto) {
    sessionStorage.setItem("session-id", uuidv4());
  }

  return (
    <Router history={history}>
      <Switch>
        <Route
          path='/admin'
          render={(props) => {
            return <AdminLayout {...props} />;
          }}
        />
        <Route
          path='/auth'
          render={(props) => {
            return <AuthLayout {...props} />;
          }}
        />
        <Redirect from='/' to='/auth/login-page' />
      </Switch>
    </Router>
  );
});

export default App;
